import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlterarSenha } from "app/models/alterar-senha.model";
import { RespostaPadrao } from "app/models/resposta-padrao.model";
import { UsuarioPerfil } from "app/models/usuario-perfil.model";
import { environment } from "environments/environment";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class UsuarioService {
    constructor(private httpClient: HttpClient) { }

    obterPerfil(): Promise<UsuarioPerfil> {
        return firstValueFrom(
            this.httpClient.get<UsuarioPerfil>(`${environment.urlApi}/Usuario/obterPerfil`)
        );
    }

    atualizarPerfil(perfil: UsuarioPerfil): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Usuario/atualizarPerfil`, perfil)
        );
    }

    alterarSenha(model: AlterarSenha): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Usuario/alterarSenha`, model)
        );
    }
}
